/**
 * The Ledger Kbd: a key, mono `--text-11` on surface-2 with a 1px border.
 * `mod` renders the platform's modifier: ⌘ on a Mac, Ctrl elsewhere (from the
 * command bar's platform detection), so a shortcut reads right everywhere.
 *
 * Spec: specs/design-system/ledger-primitives.feature
 */
import {
  Kbd as ChakraKbd,
  type KbdProps as ChakraKbdProps,
} from "@chakra-ui/react";
import * as React from "react";
import { getModifierKeyDisplay } from "~/features/command-bar/utils/platform";

export interface KbdProps extends ChakraKbdProps {
  /** Render the platform modifier key (⌘ or Ctrl) instead of children. */
  mod?: boolean;
}

export const Kbd = React.forwardRef<HTMLElement, KbdProps>(function Kbd(
  { mod = false, children, style, ...rest },
  ref,
) {
  const label = mod ? getModifierKeyDisplay() : children;
  return (
    <ChakraKbd
      ref={ref}
      size="sm"
      // tokens.css sizes every <kbd> at 0.93em, unlayered, which outranks the
      // recipe; the Ledger Kbd is --text-11 wherever it sits.
      style={{ fontSize: "var(--text-11)", ...style }}
      {...rest}
    >
      {label}
    </ChakraKbd>
  );
});
